import type { App, Project } from '@hangar/shared';
import type { Profile, ProviderAccount } from '@/api/schemas';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { ProfileForm } from './ProfileForm';

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  app: App;
  project: Project;
  /** Edit this profile (slug and platform stay). */
  editing?: Profile;
  /** Create a new profile prefilled from this one ("Duplicate"). */
  duplicateOf?: Profile;
  accounts: ProviderAccount[] | undefined;
}

/**
 * Create, duplicate or edit a build profile. The first block is the one decision (platform, provider account, CI
 * client mode, EAS profile, artifact, environments, timeout); verification, submit defaults and the launch form sit
 * under "Advanced". EAS profile names follow the API's rule (EAS_PROFILE_NAME_PATTERN), checked here and, for a 422,
 * shown next to the field that caused it. The form itself is `ProfileForm`; its logic is `profileFormModel.ts`,
 * `profileFormValidation.ts`, `profilePayload.ts` and the `useProfileForm` hook.
 */
export function ProfileSheet({ open, onOpenChange, app, project, editing, duplicateOf, accounts }: Props) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" data-testid="profile-sheet" className="w-full gap-0 p-0" aria-describedby="profile-desc">
        {open ? <ProfileForm key={editing?.id ?? `copy-${duplicateOf?.id ?? 'new'}`} app={app} project={project} editing={editing} duplicateOf={duplicateOf} accounts={accounts} onDone={() => onOpenChange(false)} /> : null}
      </SheetContent>
    </Sheet>
  );
}
